import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';

import RxOrderContainer from "../../containers/RxOrder";
import { Select } from '@material-ui/core';


interface Props {
  meganetColorTypeId: number,
  meganetColorId: number,
  meganetDensityId: number | undefined,
  onChange: (meganetDensityId: number) => void,
}

export default ((props) => {
  const rxOrderContainer = RxOrderContainer.useContainer();
  const meganetDensityId = props.meganetDensityId || rxOrderContainer.colors[0].meganetDensityId;

  useEffect(() => {
    if (props.meganetDensityId === undefined) {
      props.onChange(meganetDensityId);
    }
  }, []);

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='denTop' label='Den Top' id='denTop' value={meganetDensityId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select}>
      <MenuItem style={{ height: 30, }} key={-1} value={-1}>--</MenuItem>
      {rxOrderContainer.getDensityByMeganetColorTypeId(props.meganetColorId, props.meganetColorTypeId).map(density => (
        <MenuItem key={density.meganetDensityId} value={density.meganetDensityId}>{density.density}</MenuItem>)
      )}
    </Field>
  );
}) as React.FC<Props>;